/**
 * View All Next Count Details Model
 * @format
 */

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Cross } from "../../../assets/icons/Cross";
import { Formik } from "formik";
import BeneficiaryJourney from "../../beneficiary_management/components/beneficiaryJourney";
import PersonalDetails from "../../beneficiary_management/components/personalDetails";
import BeneficiaryAllDetail from "../../beneficiary_management/components/beneficiaryAllDetail";
import { searchBeneficiary } from "../slice";
import BeneficiaryDetailWithCurrentStatus from "../../beneficiary_management/components/beneficiaryDetailWithCurrentStatus";
import { selectSearchBeneficiaryDetails } from "../selector";
import { AssessmentComponent } from "../../beneficiary_management/components/assessmentCard";
import { FabricationComponent } from "../../beneficiary_management/components/fabricationCard";
import { DistributionComponent } from "../../beneficiary_management/components/distributionCard";
import { manipulateDateAndTime } from "../../../utils";
import BeneficiaryVerificationPart from "../../beneficiary_management/components/beneficiaryVerificationForm";

const LookUpBeneficaryModels = ({ toggleModal }) => {
  const [beneficiaryDetailToggle, setBeneficiaryDetailToggle] = useState(false);
  const [beneficiary, setBeneficiary] = useState(null);
  const [dateTime, setDateTime] = useState({});
  const scrollableRef = useRef(null);
  // const beneficiaryData = beneficiary || {};
  const {
    beneficiaryDetails: beneficiaryData = {},
    beneficiaryJourney,
    campData,
  } = useSelector(selectSearchBeneficiaryDetails) || {};
  const dispatch = useDispatch();

  const initialValues = {
    search: "",
  };

  // format the verification data and status
  const verification_data =
    beneficiaryJourney?.stages?.verification?.data?.reduce(
      (latest, current) => {
        return new Date(latest.createdAt) > new Date(current.createdAt)
          ? latest
          : current;
      },
      beneficiaryJourney?.stages?.verification?.data[0] // Correct reference here
    );

  const latest_data = {
    status: verification_data?.status_id?.status_name,
    created_by_name: verification_data?.created_by?.name,
    member_id: verification_data?.created_by?.member_id,
    call_status: verification_data?.data[0]?.call_status,
    notes: verification_data?.data[0]?.notes,
    createdAt: manipulateDateAndTime(verification_data?.createdAt),
  };

  // assessment data status managae
  const assessment_last_Status =
    beneficiaryJourney?.stages?.assessments?.data?.reduce(
      (latest, current) => {
        return new Date(latest.createdAt) > new Date(current.createdAt)
          ? latest
          : current;
      },
      beneficiaryJourney?.stages?.assessments?.data[0] // Correct reference here
    )?.status_id?.status_name;

  // Distribution data status manage
  const distribution_last_Status =
    beneficiaryJourney?.stages?.distribution?.data?.reduce(
      (latest, current) => {
        return new Date(latest.createdAt) > new Date(current.createdAt)
          ? latest
          : current;
      },
      beneficiaryJourney?.stages?.distribution?.data[0] // Set the first item as the initial value
    )?.status_id?.status_name; // Access status_name after reduce

  //  journey Steps
  const steps = [
    {
      name: "Registration",
      campScheduled: "",
      campComplete: `Completed on ${dateTime.date}; ${dateTime.time}`,
      campNotSchedled: "",
      descriptions: `Completed on ${dateTime.date}; ${dateTime.time}`,
    },
    {
      name: "Verification",
      component: (
        <BeneficiaryVerificationPart
          userData={beneficiaryData}
          userVerificationData={latest_data}
        />
      ),
      campScheduled: "",
      campNotSchedled: "",
      campComplete: `Completed on ${latest_data?.createdAt?.date}; ${
        latest_data?.createdAt?.time
      } By ${latest_data?.created_by_name} (Sai Connect ID ${
        latest_data?.member_id || ""
      })`,
      lastStatus: "complete",
      // descriptions: `Completed on ${latest_data?.createdAt?.date}; ${
      //   latest_data?.createdAt?.time
      // } By ${latest_data?.created_by_name} (Sai Connect ID ${
      //   latest_data?.member_id || ""
      // })`,
    },
    {
      name: "Assessment",
      component: (
        <AssessmentComponent
          campData={campData?.assessment}
          beneficiary_id={beneficiaryData?._id}
        />
      ),
      campComplete: ``,
      campNotSchedled: !campData?.assessment ? `Not yet scheduled` : "",
      disabled: campData?.assessment ? false : true,
      lastStatus:
        assessment_last_Status === "assessement_complete"
          ? "complete"
          : assessment_last_Status === "assessment_in_progress"
          ? "in_progress"
          : "",
      descriptions: `Started on 23-01-2024; 11.25 AM`,
    },
    {
      name: "Fabrication",
      component: <FabricationComponent />,
      campScheduled: "",
      campComplete: ``,
      campNotSchedled: `Not yet scheduled`,
      disabled: campData?.fabrication ? false : true,
      lastStatus: "in_progress",
      descriptions: `Started on 23-01-2024; 11.25 AM | Completed on 23-01-2024; 11.25 AM`,
    },
    {
      name: "Distribution",
      component: <DistributionComponent />,
      campComplete: ``,
      campNotSchedled: !campData?.distribution ? `Not yet scheduled` : "",
      disabled: campData?.distribution ? false : true,
      lastStatus:
        distribution_last_Status === "distribution_complete"
          ? "complete"
          : distribution_last_Status === "distribution_in_progress"
          ? "in_progress"
          : "",
      descriptions: `Started on 23-01-2024; 11.25 AM`,
    },
  ];

  useEffect(() => {
    if (
      scrollableRef.current &&
      typeof scrollableRef.current.scrollTo === "function"
    ) {
      scrollableRef.current.scrollTo(0, 0);
    } else if (beneficiaryData?._id) {
      const result = manipulateDateAndTime(beneficiaryData?.createdAt);
      setDateTime(result);
    }
  }, [beneficiaryData]);

  return (
    <div className="fixed h-full inset-0 z-50 flex justify-end">
      <div className="fixed inset-0 bg-[#07284B] opacity-50"></div>
      <div
        data-aos-easing="linear"
        data-aos="fade-left"
        className="flex flex-col relative w-[55%] bg-white h-full shadow-lg overflow-y-auto scrollbar-hide"
      >
        <div className="flex justify-between items-center bg-customBlue-mainBackground w-full h-[11%] p-5">
          <h2 className="text-xl font-bold">Lookup Beneficiary</h2>
          <button onClick={toggleModal} className="text-xl font-semibold">
            <Cross width={32} height={32} />
          </button>
        </div>
        {/* Modal content */}
        <div className="w-full flex flex-col flex-auto justify-start space-y-4 py-6 px-6">
          {/* Search Input fields */}
          <div className="container p-0 text-black">
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object().shape({
                search: Yup.string()
                  .required("Reg. Number Or Mobile Number are required")
                  .max(10, "cannot exceed 10 characters"),
              })}
              onSubmit={(values, actions) => {
                const { search } = values;
                dispatch(
                  searchBeneficiary({
                    search,
                    onSuccess: (props) => {
                      // console.log(props?.data);
                      // setBeneficiary(props?.data);
                      setBeneficiaryDetailToggle(true);
                      actions.resetForm();
                    },
                  })
                );
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSubmit();
                    }
                  }}
                >
                  <div className="container p-0 flex justify-start items-center h-full">
                    <div className="flex flex-col gap-1.5 w-full">
                      <label className="text-sm font-bold">
                        Beneficiary Reg. no / Mobile no
                      </label>
                      <div className="relative h-[40px] rounded-xl w-full">
                        <button
                          type="submit"
                          className="absolute inset-y-0 end-6 flex text-sm items-center ps-5 h-full underline text-activeLink decoration-activeLink"
                        >
                          Lookup
                        </button>
                        <input
                          autoComplete="off"
                          type="text"
                          maxLength={10}
                          name="search"
                          id="search"
                          onChange={(e) => {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.value.toUpperCase(),
                              },
                            });
                          }}
                          value={values.search}
                          onBlur={handleBlur}
                          placeholder="Enter Here"
                          className="block w-full h-full p-4 text-sm font-DM rounded-xl search-bar border border-customBlue-border placeholder-black"
                        />
                        {touched.search && errors.search && (
                          <div className="mt-1 text-xs text-red-500">
                            {errors.search}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>

          {/* Beneficiary Details */}
          <div className="flex justify-center items-center w-full overflow-y-auto scrollbar-hide px-0">
            {beneficiaryDetailToggle &&
            Object.keys(beneficiaryData)?.length > 0 ? (
              beneficiaryData?.status === "Verified" ? (
                <div className="container p-0 h-full self-end w-full ">
                  <div
                    className="container h-full overflow-y-scroll scrollbar-hide space-y-6 flex flex-col bg-white px-4 py-4 max-w-full w-full rounded-xl"
                    // ref={scrollableRef}
                  >
                    {/* Beneficiary Detail */}
                    <BeneficiaryDetailWithCurrentStatus
                      userData={beneficiaryData}
                    />

                    {/* Personal Detail */}
                    <div className="container p-0 flex flex-col justify-between max-w-full w-full  ">
                      <PersonalDetails userData={beneficiaryData} />
                    </div>
                    {/* Beneficiary Journey */}
                    <div className="container p-0 flex flex-col justify-between items-center max-w-full w-full  ">
                      <BeneficiaryJourney
                        beneficiary={beneficiaryData}
                        beneficiaryJourney={beneficiaryJourney}
                        steps={steps}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <BeneficiaryAllDetail
                  singleBeneficiary={beneficiaryData}
                  data={beneficiaryData}
                  bySearch={true}
                />
              )
            ) : (
              <div className="flex justify-center items-center container pr-4 pt-2 h-full self-end w-full bg-white rounded-lg"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { LookUpBeneficaryModels };
